/* 팝업의 전역변수 설정. 나중엔 임베딩 위치를 바꾸어야 할 지도 모르겠는데.. */
$(document).ready(function(e) {
	// mfp
	if( $.magnificPopup != undefined ) {
		$.magnificPopup.defaults.fixedBgPos = true;
		$.magnificPopup.defaults.closeOnBgClick = false;
		$.magnificPopup.defaults.removalDelay = 300;
		$.magnificPopup.defaults.mainClass = "animated";
	}
});


/**
 * Created by namsu.park on 2017-03-07.
 */
/* Golbal Menu - BSPSelectBox */
function BSPSelectBox($container) {
    this.$container = $container;
    this.$btnSelect;
    this.$listContainer;
    this.$searchContainer;
    this.$listItems;

    this.init();
}

BSPSelectBox.prototype.init = function() {
    var _ = this;

    _.$btnSelect = _.$container.find('.btn-custom-select');
    _.$listContainer = _.$container.find('.list-container');
    _.$searchContainer = _.$container.find('.search-word');
    _.$textField = _.$searchContainer.find('input[type=text]');
    _.$listItems = _.$listContainer.find('button');

    _.initEvent();
}

BSPSelectBox.prototype.initEvent = function() {
    var _ = this;

    _.$btnSelect.off('click').on('click', function(e) {
        $(this).toggleClass("is-selected");

        _.$listContainer.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function() {
            _.$textField.focus();
        });

    });

    _.$btnSelect.on('keydown', function(e) {
        switch(e.keyCode) {
            case 40: {
                _.$listContainer.find('button:visible').eq(0).focus();
                break;
            }
        }
    })

    _.$listItems.off('click').on('click', function(e) {
        _.select($(this));
    });

    _.$listItems.on('keydown', function(e) {
        switch(e.keyCode) {
            case 38: {
                var $items = _.$listContainer.find('button:visible');
                var index = $items.index(this);
                if( index == 0 ) {
                    _.$textField.focus();
                } else {
                    $items.eq(index-1).focus();
                }
                break;
            }

            case 40: {
                var $items = _.$listContainer.find('button:visible');
                var index = $items.index(this);
                $items.eq(index+1).focus();
                break;
            }
        }
    });

    _.$textField.on('keyup', function(e) {
        var keyword = e.target.value.toString();
        var $btns = _.$listContainer.find('.list-custom-select button');
        if( keyword.length <= 0 ) {
            $btns.closest('li').removeClass('not-match');
        }
        $.each($btns, function(index, element) {
            var orgText = $(element).html();
            orgText = orgText.replace('<mark>', '').replace('</mark>', '');
            var startIdx = orgText.toUpperCase().indexOf(keyword.toUpperCase());
            var length = keyword.length;
            var markWord = orgText.substr(startIdx, length);
            if(orgText.toUpperCase().indexOf(keyword.toUpperCase()) !== -1){
                var newText = orgText.replace(markWord, '<mark>'+markWord+'</mark>');
                $(element).html(newText);
                $(element).closest('li').removeClass('not-match');
            } else {
                $(element).closest('li').addClass('not-match');
            }
        });
        switch(e.keyCode) {
            case 40: {
                _.$listContainer.find('button:visible').eq(0).focus();
                break;
            }
        };
    });
}

BSPSelectBox.prototype.hide = function() {
    var _ = this;

    _.$btnSelect.removeClass("is-selected")
}

BSPSelectBox.prototype.select = function($item) {
    var _ = this;

    _.$listItems.closest('li').removeClass('is-selected');
    $item.closest('li').addClass('is-selected');

    // _.$btnSelect.html($item.html());
    _.hide();
}

BSPSelectBox.prototype.resetSearchWord = function() {
    var _ = this;

    _.$textField.val('').trigger('keyup');
}
/* GlobalMenu */
exports.Footer = (function ($) {
    var scope,
        $container,
        $popupSupport,
        selectLanguage,
        $user,
        init = function() {
            $container = $('.layout-footer');

            $popupSupport = $container.find('[data-trigger=popup-support]');
            selectLanguage = new BSPSelectBox($('#language'));

            initLayout();
            initEvent();
        };

    function initLayout() {

    }

    function initEvent() {
        $popupSupport.magnificPopup();

        $(document).click(function (e) {
            if( !$(event.target).closest("#language").length ) {
                selectLanguage.hide();
            }
        });
    }
    return {
        init: function() {
            init();
        }
    };
}(jQuery));



//////////////////
// WEBPACK FOOTER
// ./src/app/components/GNB/footer/footer.js
// module id = ./src/app/components/GNB/footer/footer.js
// module chunks = main